import moment from 'moment'
import { takeEvery, call, put, all } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import { LOAD_VIDEOLISTS_ALL, loading, putVideolistsAll } from '../../store/ContentAllVideolists/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'

export default function* () {
    yield takeEvery(LOAD_VIDEOLISTS_ALL, worker)
}

function* worker() {
    yield put(loading(true))
    try {
        let videolists = [],
            songsAssoc = {}
        const fetchedVideolists = yield call(fetchVideolists)

        if (fetchedVideolists.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${LOAD_VIDEOLISTS_ALL}.`, fetchedVideolists],
                text: "Ролики не были загружены. Попробуйте перезагрузить страницу."
            }))
            yield put(putVideolistsAll({ videolists }))

        } else {
            videolists = fetchedVideolists.success.map(list => {
                let totalsize2 = 0;
                if (list.totalsize) {
                    let size = Math.floor(list.totalsize / 1024 / 1024);
                    size = !size ? `${Math.floor(list.totalsize / 1024 )} Kb` : `${size} Mb`
                    totalsize2 = size
                }
                list.totalsize2 = totalsize2
                list.songs = []
                return list;
            })

            // if (fpl[0]) {
            //     const videos = yield all(
            //         fpl.map(videolist => call(fetchVideo, videolist.id))
            //     )
            //
            //     // alert(JSON.stringify(songs.map(song => song.success)))
            //     videolists = videos.map(video => {
            //         video.success = { ...video.success[0], songs: video.success.songs }
            //         Object.values(video.success.songs).map(track => {
            //             track.filename = buildGETUrl("clip/play", { id: track.id })
            //         })
            //         return video.success
            //     })
            // }
            //playlists = fpl
            //alert(JSON.stringify(playlists))
            //playlists = playlists.success
            //playlists.map(playlist => songsAssoc[playlist.id] = playlist)
            yield put(putVideolistsAll({ videolists }))
        }
    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${LOAD_VIDEOLISTS_ALL}.`, e],
            text: "Плейлисты не были загружены. Попробуйте перезагрузить страницу."
        }))
        yield put(putVideolistsAll({ videolists: [] }))
    }

    finally {
        yield put(loading(false))
    }
}

function fetchVideolists() {
    return axios.get("/videolist/select")
        .then(response => response.data)
}

function fetchVideo(videolistId) {
    return axios.get(`/videolist/get?id=${videolistId}`)
        .then(response => response.data)
}